import React from "react";
import { ActionProps } from "react-querybuilder";

export const CustomAddGroupAction: React.FC<ActionProps> = (props) => {
    return null;
};
